module.exports = __webpack_public_path__ + "img/jose-vega.4816f9a4.png";